import React from 'react';
interface PageHeroProps {
  label: string;
  title: string;
  subtitle?: string;
}
export function PageHero({
  label,
  title,
  subtitle
}: PageHeroProps) {
  return <div className="py-14 relative overflow-hidden" style={{
    backgroundImage: 'radial-gradient(circle, rgba(15, 31, 61, 0.03) 1px, transparent 1px)',
    backgroundSize: '20px 20px'
  }} data-id="element-369">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-370">
        <span className="text-primary/50 font-semibold tracking-wider uppercase text-xs" data-id="element-371">
          {label}
        </span>
        <h1 className="mt-3 text-3xl md:text-4xl font-heading font-bold text-primary" data-id="element-372">
          {title}
        </h1>
        <div className="mt-4 mx-auto w-20 h-[3px] rounded-full bg-gradient-to-r from-primary to-primary/30" data-id="element-373" />
        {subtitle && <p className="mt-5 text-base text-gray-600 max-w-2xl mx-auto" data-id="element-374">
            {subtitle}
          </p>}
      </div>
    </div>;
}